export const imgData = {
  1: {
    illus: {
      w: 528,
      h: 399,
    },
    sub1: {
    },
    sub2: {
      w: 136,
      h: 79
    }
  },
  2: {
    illus: {
      w: 556,
      h: 399,
    },
    sub1: {
      w: 41,
      h: 88
    },
    sub2: {
      w: 57,
      h: 110
    }
  },
  3: {
    illus: {
      w: 583,
      h: 399,
    },
    sub1: {
      w: 24,
      h: 59
    },
    sub2: {
      w: 51,
      h: 101
    }
  },
  4: {
    illus: {
      w: 584,
      h: 402,
    },
    sub1: {
      w: 101,
      h: 90
    },
    sub2: {
      w: 86,
      h: 50
    }
  },
  5: {
    illus: {
      w: 604,
      h: 399,
    },
    sub1: {
      w: 78,
      h: 64
    },
    sub2: {
      w: 106,
      h: 85
    }
  },
  6: {
    illus: {
      w: 613,
      h: 399,
    },
    sub1: {
      w: 99,
      h: 78
    },
    sub2: {
      w: 57,
      h: 56
    }
  },
  7: {
    illus: {
      w: 550,
      h: 399,
    },
    sub1: {
      w: 96,
      h: 113
    },
    sub2: {}
  },
  8: {
    illus: {
      w: 519,
      h: 399,
    },
    sub1: {
      w: 24,
      h: 59
    },
    sub2: {
      w: 99,
      h: 107
    }
  },
}
